import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { UserStatus } from '@user-management/user-details';
import {
  parseAsInteger,
  parseAsString,
  parseAsStringEnum,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

type SortOrder = (typeof dataGridSortDirection)[number];

export function useUserManagementListSearchParams() {
  const [searchParams, setSearchParams] = useQueryStates(
    {
      search: parseAsString.withDefault(''),
      page: parseAsPageNumber.withDefault(0),
      pageSize: parseAsInteger.withDefault(10),
      sortBy: parseAsString.withDefault('lastLoginAt'),
      sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
      status: parseAsStringEnum(Object.values(UserStatus)),
      role: parseAsString.withDefault(''),
    },
    {
      urlKeys: {
        search: 'q',
      },
    },
  );

  const changePageNumber = (page: number) => {
    setSearchParams({ page });
  };

  const changeStatus = (status: UserStatus) => {
    setSearchParams({ status, page: 0, sortOrder: null });
  };

  const changePageSize = (pageSize: number) => {
    setSearchParams({ pageSize, page: 0 });
  };

  const changeSearch = (search: string) => {
    setSearchParams({ search, page: 0 });
  };

  const changeSorting = ({
    sortOrder,
    sortBy,
  }: {
    sortOrder: SortOrder | null;
    sortBy: string | null;
  }) => {
    setSearchParams({ sortOrder, page: 0, sortBy });
  };

  const changeRoleAndStatus = (role: string, status: UserStatus | null) => {
    setSearchParams({ role: role, status, page: 0 });
  };

  return [
    searchParams,
    {
      changePageNumber,
      changePageSize,
      changeStatus,
      changeSorting,
      changeSearch,
      changeRoleAndStatus,
    },
  ] as const;
}
